import React from 'react';
import classNames from 'classnames';
import styles from './styles.module.scss';

const ModalContent = ({
                        children,
                        isScrollable = false,
                        customClassnames = '',
                      }) => {

  return (
    <div className={classNames(
      styles.complex,
      isScrollable && styles.scrollable,
      customClassnames
    )}>
      {children}
    </div>
  );
};

export default ModalContent;